import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  return <>
      <footer className="bg-brand-darker text-slate-500 py-8 text-center text-sm border-t border-slate-800" data-id="element-20">
        <p className="mb-3" data-id="element-21">
          © {new Date().getFullYear()} Guía de Micro-Emprendimientos. Todos los
          derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-22">
          <button onClick={() => setTermsOpen(true)} className="hover:text-brand-accent transition-colors underline underline-offset-2" data-id="element-23">
            Términos y Condiciones
          </button>
          <span className="text-slate-700" data-id="element-24">|</span>
          <button onClick={() => setPrivacyOpen(true)} className="hover:text-brand-accent transition-colors underline underline-offset-2" data-id="element-25">
            Política de Privacidad
          </button>
        </div>
      </footer>

      {/* Terms Modal */}
      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-26">
        <p className="font-bold text-slate-900" data-id="element-27">
          1. Aceptación de los Términos
        </p>
        <p data-id="element-28">
          Al adquirir y/o utilizar la "Guía de Micro-Emprendimientos para
          Hombres y Mujeres" (en adelante, "el Producto"), usted acepta cumplir
          con los presentes Términos y Condiciones. Si no está de acuerdo, le
          solicitamos no realizar la compra.
        </p>

        <p className="font-bold text-slate-900" data-id="element-29">2. Descripción del Producto</p>
        <p data-id="element-30">
          El Producto es una guía digital en formato PDF que incluye plantillas,
          checklists y ejemplos orientados a la creación de
          micro-emprendimientos digitales. El contenido es de carácter
          informativo y educativo.
        </p>

        <p className="font-bold text-slate-900" data-id="element-31">3. Entrega del Producto</p>
        <p data-id="element-32">
          Una vez confirmado el pago, recibirá acceso inmediato al Producto a
          través de un enlace de descarga enviado al correo electrónico
          proporcionado durante la compra.
        </p>

        <p className="font-bold text-slate-900" data-id="element-33">4. Propiedad Intelectual</p>
        <p data-id="element-34">
          Todo el contenido del Producto está protegido por derechos de autor.
          Queda prohibida su reproducción, distribución, modificación o reventa
          total o parcial sin autorización expresa por escrito.
        </p>

        <p className="font-bold text-slate-900" data-id="element-35">5. Política de Reembolso</p>
        <p data-id="element-36">
          Debido a la naturaleza digital del Producto, no se aceptan
          devoluciones ni reembolsos una vez realizada la descarga. Si
          experimenta problemas técnicos con la descarga, puede contactarnos
          para recibir asistencia.
        </p>

        <p className="font-bold text-slate-900" data-id="element-37">
          6. Limitación de Responsabilidad
        </p>
        <p data-id="element-38">
          Los resultados obtenidos al aplicar el contenido de la guía dependen
          exclusivamente de las acciones del usuario. No garantizamos ingresos
          específicos ni resultados financieros determinados.
        </p>

        <p className="font-bold text-slate-900" data-id="element-39">7. Modificaciones</p>
        <p data-id="element-40">
          Nos reservamos el derecho de modificar estos Términos y Condiciones en
          cualquier momento. Las modificaciones serán efectivas desde su
          publicación.
        </p>
      </LegalModal>

      {/* Privacy Modal */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-41">
        <p className="font-bold text-slate-900" data-id="element-42">
          1. Información que Recopilamos
        </p>
        <p data-id="element-43">
          Al realizar una compra, recopilamos únicamente la información
          necesaria para procesar su pedido: nombre y dirección de correo
          electrónico. No almacenamos datos de tarjetas de crédito ni
          información financiera.
        </p>

        <p className="font-bold text-slate-900" data-id="element-44">2. Uso de la Información</p>
        <p data-id="element-45">
          La información recopilada se utiliza exclusivamente para: enviar el
          Producto adquirido, brindar soporte técnico en caso de ser necesario,
          y enviar comunicaciones relacionadas con el Producto (solo si el
          usuario lo autoriza).
        </p>

        <p className="font-bold text-slate-900" data-id="element-46">3. Protección de Datos</p>
        <p data-id="element-47">
          Implementamos medidas de seguridad razonables para proteger su
          información personal contra acceso no autorizado, alteración o
          destrucción.
        </p>

        <p className="font-bold text-slate-900" data-id="element-48">4. Compartir Información</p>
        <p data-id="element-49">
          No vendemos, intercambiamos ni transferimos su información personal a
          terceros. La única excepción son los proveedores de servicios de pago
          necesarios para procesar su transacción.
        </p>

        <p className="font-bold text-slate-900" data-id="element-50">5. Cookies</p>
        <p data-id="element-51">
          Nuestro sitio puede utilizar cookies para mejorar la experiencia del
          usuario. Puede configurar su navegador para rechazar cookies, aunque
          esto podría afectar algunas funcionalidades.
        </p>

        <p className="font-bold text-slate-900" data-id="element-52">6. Derechos del Usuario</p>
        <p data-id="element-53">
          Usted tiene derecho a solicitar acceso, corrección o eliminación de
          sus datos personales en cualquier momento.
        </p>

        <p className="font-bold text-slate-900" data-id="element-54">7. Cambios en la Política</p>
        <p data-id="element-55">
          Nos reservamos el derecho de actualizar esta Política de Privacidad.
          Cualquier cambio será publicado en esta página.
        </p>
      </LegalModal>
    </>;
}